import { render, staticRenderFns } from "./DialogEditarFormaPagamento.vue?vue&type=template&id=2fc804fd&"
import script from "./DialogEditarFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./DialogEditarFormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports